import 'webpack-jquery-ui/autocomplete'
import 'jquery-mask-plugin'
import NativeDateField from './native-date-field'
import AutocompleteField from './autocomplete-field'
import PasswordField from './password-field'
import RadioListField from './radion-list-field'
import CheckBoxSetField from './checkbox-set-field'
/**
 * Handle inputs initiation
 */
export default {
  mixins: [
    NativeDateField,
    AutocompleteField,
    PasswordField,
    RadioListField,
    CheckBoxSetField,
  ],
  data: () => ({
    inputs: []
  }),
  computed: {
    requiredInputs() {
      return this.inputs
        .filter(i => i.isRequired)
    }
  },
  methods: {
    initInputs() {
      const inputs = this.form.find('[data-field-type]')
      inputs.each((i, el) => {
        this.initInput(i, el)
      })
    },
    initInput(i, el) {
      let inputObj = {
        id: $(el).attr('id'),
        el: $(el),
        index: i,
        name: $(el).attr('name'),
        fieldType: $(el).data('field-type'),
        isRequired: $(el).data('val') && $(el).data('val-required'),
        haveRequiredValue: !($(el).data('val') && $(el).data('val-required')) || !$(el).val(),
        getValue: () => $(el).val()
      }
      if (typeof this[`init${inputObj.fieldType}`] === 'function') {
        inputObj = this[`init${inputObj.fieldType}`](inputObj)
      }
      if (inputObj) {
        if (inputObj.el.data('clear')) {
          this.insertClearBehavior(inputObj)
        }
        if (inputObj.el.data('mask')) {
          inputObj.el.mask(inputObj.el.data('mask'))
        }
        if (inputObj.el.data('default-value')) {
          inputObj.el.val(inputObj.el.data('default-value'))
        }
        if (typeof this.inputsCallback === 'function') {
          this.inputsCallback(inputObj)
        }
        inputObj.el.on('input', this.checkIfValue.bind(this, inputObj))
        inputObj.el.on('change', this.checkIfValue.bind(this, inputObj))
        this.inputs.push(inputObj)
        setTimeout(() => {
          this.checkIfValue(inputObj)
        }, 500)
      }
    },
    removeInput(inputObj) {
      this.inputs.splice(inputObj.index, 1)
      this.reindexInputs()
    },
    reindexInputs() {
      this.inputs = this.inputs.map((inputObj, i) => ({ ...inputObj, index: i }))
    },
    initConditions() {
      const conditions = this.form.find('[data-condition-field-id]')
      conditions.each((i, el) => {
        const inputId = el.getAttribute('data-condition-field-id')
        if (!inputId) return
        const operatorType = el.getAttribute('data-condition-operator-type')
        const actionType = el.getAttribute('data-condition-action-type')
        const value = el.getAttribute('data-condition-value')
        const input = this.form.find(`[data-sc-field-key=${inputId}]`)
        el.listener = this.checkCondition.bind(this, operatorType, actionType, value, el)
        input.on('change', el.listener)
        input.on('select', el.listener)
      })
    },
    checkCondition(operatorType, actionType, value, el, e) {
      if (operatorType === 'IsEqualTo') {
        const methodAction = actionType === 'Show' ? 'remove' : 'add'
        const methodRemoveAction = actionType === 'Show' ? 'add' : 'remove'
        if (e.target.value === value) {
          el.classList[`${methodAction}`]('hide')
        } else {
          el.classList[`${methodRemoveAction}`]('hide')
        }
      }
    },
    destroyConditions() {
      const conditions = this.form.find('[data-condition-field-id]')
      conditions.each((i, el) => {
        const inputId = el.getAttribute('data-condition-field-id')
        const input = this.form.find(`input#${inputId}`)
        input.off('input', el.listener)
      })
    },
    updateDefaultValues() {
      this.inputs.forEach(inputObj => {
        if (inputObj.el.data('default-value')) {
          inputObj.el.val(inputObj.el.data('default-value'))
        }
      })
    },
    reInitInputs() {
      const inputs = this.form.find('[data-field-type]')
      const inputHtmls = inputs.map((i, o) => $(o)[0].outerHTML).toArray()
      const removedInputs = this.inputs.filter(inputObj => {
        return !inputHtmls.includes(inputObj.el[0].outerHTML)
      })
      const newInputs = inputs.filter((i, input) => {
        const inputHtml = $(input)[0].outerHTML
        const currentInputs = this.inputs.map(inp => inp.el[0].outerHTML)
        return !currentInputs.includes(inputHtml)
      })
      removedInputs.forEach(inputObj => this.removeInput(inputObj))
      newInputs.each((i, el) => this.initInput(i, el))
    },
    // Clear behavior
    insertClearBehavior(inputObj) {
      inputObj.clearBtn = $('<i class="fa fa-close clear-input"></i>').insertBefore(inputObj.el)
      const updateClearIcon = () => {
        const value = inputObj.el.val()
        if (value) {
          inputObj.clearBtn.addClass('show')
          inputObj.el.parent().addClass('clearable')
        } else {
          inputObj.clearBtn.removeClass('show')
          inputObj.el.parent().removeClass('clearable')
        }
      }
      inputObj.el.on('input', updateClearIcon)
      inputObj.el.on('change', updateClearIcon)
      inputObj.clearBtn.on('click', () => {
        inputObj.el.val('')
        inputObj.el.change()
      })
    },
    // No value behavior
    checkIfValue(inputObj) {
      const value = inputObj.getValue()
      this.getValidationErrors()
      if (!value) {
        inputObj.el.addClass('no-value')
        inputObj.el.removeClass('have-value')
      } else {
        inputObj.el.removeClass('no-value')
        inputObj.el.addClass('have-value')
      }
      if (inputObj.isRequired) {
        inputObj.haveRequiredValue = !!value
      }
    }
  },
}
